import type { TabEntity, DefaultTab } from './schemas';
import { animationFeature } from '../features';
import { createEntityMeta } from '../utils';

const baseDefaults = {
    id: '',
    parentId: '',
    entityType: 'tab' as const,
    children: [] as unknown[],
};

export const createDefaultDefaultTab = (): DefaultTab => ({
    ...baseDefaults,
    meta: createEntityMeta(),
    version: 1,
    entitySubType: 'default',
    props: {
        placement: 'top',
        header: {
            width: {
                desktop: {
                    value: 20,
                    unit: '%',
                },
            },
            backgroundColor: {
                desktop: '#ffffff',
            },
            activeBackgroundColor: {
                desktop: '#f1f5f9',
            },
            textColor: {
                desktop: '#1f2933',
            },
            fontSize: {
                desktop: {
                    value: 18,
                    unit: 'px',
                },
            },
            fontWeight: {
                desktop: 'initial',
            },
            fontStyle: {
                desktop: 'initial',
            },
            textTransform: {
                desktop: 'initial',
            },
            activeTextColor: {
                desktop: '#0f172a',
            },
            activeContourColor: {
                desktop: '#3b82f6',
            },
            activeContourSide: {
                desktop: 'bottom',
            },
            padding: {
                desktop: {
                    value: {
                        left: 18,
                        right: 18,
                        top: 12,
                        bottom: 12,
                    },
                    unit: 'px',
                },
            },
            borderRadius: {
                desktop: {
                    value: {
                        topLeft: 0,
                        topRight: 0,
                        bottomLeft: 0,
                        bottomRight: 0,
                    },
                    unit: 'px',
                },
            },
            separator: {
                desktop: true,
            },
            separatorColor: {
                desktop: '#e2e8f0',
            },
        },
        body: {
            backgroundColor: {
                desktop: '#ffffff',
            },
            borderRadius: {
                desktop: {
                    value: {
                        topLeft: 0,
                        topRight: 0,
                        bottomLeft: 0,
                        bottomRight: 0,
                    },
                    unit: 'px',
                },
            },
            padding: {
                desktop: {
                    value: {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    },
                    unit: 'px',
                },
            },
        },
        tabs: [],
        animation: animationFeature.createDefault(),
    },
});

export const createDefaultTab = (entitySubType: 'default' = 'default'): TabEntity => {
    return createDefaultDefaultTab();
};
